function isEventTarget(target) {
  return !!target && !!target.addEventListener && !!target.removeEventListener;
}
export default isEventTarget;